import React, { useState, useEffect, useCallback } from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Navbar from '../../Navbar';
import Footer from '../Footer/Footer';
import './admin.css';
import axios from 'axios';
import studentPhoto from '../../img/studentIcon.png';
import adminBack from '../../images/images/Admindash.png';

// Default import is the most stable across different versions of this library
import QRCode from 'qrcode.react'; 

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faCheckCircle, faHome, faRightFromBracket, 
    faBell, faUserShield 
} from '@fortawesome/free-solid-svg-icons';

const BANK_BACKEND_URL = "https://sangrahapi.myearth.id/api/v1/users";
//const BANK_BACKEND_URL = "http://localhost:5001/api/v1/users";
const MySwal = withReactContent(Swal);

const SidebarButton = ({ label, icon, onClick, isSelected, customClassName }) => {
    return (
        <button
            className={`sidebarbtn ${isSelected ? 'selected' : ''} ${customClassName}`}
            onClick={onClick}
        >
            <FontAwesomeIcon className="bellIcon" icon={icon} />
            {label}
        </button>
    );
};

const Admin = () => {
    const [selectedButton, setSelectedButton] = useState('Home');
    const [kycUsers, setKycUsers] = useState([]);
    const [loading, setLoading] = useState(false);

    // --- ASSISTANT DATA CONFIGURATION ---
    const assistantConfig = {
        assisted: true,
        requestType: "assisted_setup",
        assistant_id: "AST-9920",
        assistant_name: "Tracy Smith",
        bank_id: "EarthID International Bank",
        channel: "Admin Portal",
    };

const fetchKycUserList = useCallback(async (isInitialLoad = false) => {
    // Only show the big loading spinner if specifically requested
    if (isInitialLoad) setLoading(true);
    try {
        const response = await axios.get(`${BANK_BACKEND_URL}/list`);
        if (response.data.success) {
            setKycUsers(response.data.data);
        }
    } catch (error) {
        console.error('Error fetching KYC users:', error);
    } finally {
        if (isInitialLoad) setLoading(false);
    }
}, []);

// Update the useEffect call:
useEffect(() => {
    let intervalId;
    if (selectedButton === 'KYC') {
        fetchKycUserList(true); // First load shows spinner
        intervalId = setInterval(() => fetchKycUserList(false), 5000); // Refreshes happen in background
    }
    return () => clearInterval(intervalId);
}, [selectedButton, fetchKycUserList]);

    const handleSendKycRequest = async (userDid) => {
        MySwal.fire({
            title: 'KYC Request',
            text: 'Sending KYC request to the user...',
            allowOutsideClick: false,
            didOpen: () => { Swal.showLoading(); },
        });

        try {
            const response = await axios.post(`${BANK_BACKEND_URL}/request-kyc`, { userDid });
            if (response.data.success) {
                MySwal.fire('Request Sent', 'KYC request sent to the user wallet.', 'success');
                fetchKycUserList(); 
            }
        } catch (error) {
            MySwal.fire('Error', 'Failed to send request', 'error');
        }
    };

const handleVerifyUser = async (bankUserId) => {
    MySwal.fire({
        title: 'Verifying Token...',
        html: `
            <div style="margin-top: 10px;">
                <p>Verifying received information...</p>
                <div class="progress-bar-container">
                    <div class="progress-bar-fill"></div>
                </div>
            </div>
        `,
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => { Swal.showLoading(); },
    });

    const delay = (ms) => new Promise(res => setTimeout(res, ms));

    try {
        const [response] = await Promise.all([
            axios.post(`${BANK_BACKEND_URL}/verify-vc`, { bankUserId }),
            delay(2000) 
        ]);
        
        if (response.data.success) {
            // 1. Find the specific user to get kycData
            const verifiedUser = kycUsers.find(u => u.bankUserId === bankUserId);
            const kyc = verifiedUser.kycData || {};

            // 2. Dynamically build the HTML list, excluding 'verifiedAt'
            const dataRows = Object.entries(kyc)
                .filter(([key]) => key !== 'verifiedAt') // 🔥 Exclude the verifiedAt field
                .map(([key, value]) => {
                    // Formatting the label (e.g., firstName -> First Name)
                    const label = key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
                    
                    // Smart formatting for date strings (if any other dates exist)
                    let displayValue = value;
                    if (typeof value === 'string' && value.includes('T') && value.endsWith('Z')) {
                        displayValue = new Date(value).toLocaleString('en-GB');
                    }

                    return `
                        <p style="margin-bottom: 8px; display: flex; justify-content: space-between; border-bottom: 1px dashed #eee; padding-bottom: 4px;">
                            <strong style="color: #764ba2;">${label}:</strong> 
                            <span style="color: #444;">${displayValue || 'N/A'}</span>
                        </p>`;
                }).join('');

            // 3. Show the dynamic popup with intro text
            MySwal.fire({
                icon: 'success',
                title: 'Token Verified successfully!',
                html: `
                    <div style="text-align: left; margin-top: 10px;">
                        <p style="font-weight: 600; color: #555; margin-bottom: 10px; font-size: 15px;">Here is the verified information:</p>
                        <div style="background: #f9f9f9; padding: 15px; border-radius: 10px; font-size: 14px; border: 1px solid #eee;">
                            ${dataRows || '<p style="text-align:center;">No data fields shared.</p>'}
                        </div>
                    </div>
                `,
                confirmButtonColor: '#764ba2',
                confirmButtonText: 'Close'
            });

            fetchKycUserList(); 
        }
    } catch (error) {
        MySwal.fire('Verification Failed', 'Error occurred while verifying the KYC token.', 'error');
    }
};

    const handleLogout = () => { window.location.href = "/"; };

    // --- SORTING LOGIC FOR LATEST AT TOP ---
    const sortedUsers = [...kycUsers].sort((a, b) => {
        const dateA = new Date(a.updatedAt || a.message.payload.data.timestamp || 0);
        const dateB = new Date(b.updatedAt || b.message.payload.data.timestamp || 0);
        return dateB - dateA; 
    });

    return (
        <>
            <div className="admin-container">
                <div className="row">
                    <div className="sidebar col-md-2">
                        <div className='stuProf'>
                            <div className="photo"><img src={studentPhoto} alt="Admin" /></div>
                            <div className='stuDentDiv'>
                                <div className='stuUserNameHead'>Admin Name</div>
                                <div className='stuUserName'>Tracy Smith</div>
                            </div>
                        </div>
                        <div className='smallHr'><hr /></div>

                        <SidebarButton label="Home" icon={faHome} onClick={() => setSelectedButton('Home')} isSelected={selectedButton === 'Home'} />
                        <SidebarButton label="KYC Management" icon={faCheckCircle} onClick={() => setSelectedButton('KYC')} isSelected={selectedButton === 'KYC'} />
                        
                        <SidebarButton 
                            label="Assisted Journey" 
                            icon={faUserShield} 
                            onClick={() => setSelectedButton('ASSISTED')} 
                            isSelected={selectedButton === 'ASSISTED'} 
                        />

                        <div className='smallHr'><hr /></div>
                        <SidebarButton label="Logout" icon={faRightFromBracket} onClick={handleLogout} customClassName='redText' />
                    </div>

                    <div className="content col-md-10">
                        <div className='row miniNav'>
                            <div className='companyy'>Admin Portal</div>
                            <FontAwesomeIcon className='bellIcon' icon={faBell} />
                        </div>

                        {selectedButton === 'Home' && (
                            <div className='adminBack'><img src={adminBack} alt="Banner" /></div>
                        )}

                        {selectedButton === 'ASSISTED' && (
                            <div style={{ padding: '40px', background: '#f8f9fa', minHeight: 'calc(100vh - 150px)', borderRadius: '20px' }}>
                                <div className='listTag' style={{ marginBottom: '30px', fontSize: '24px', fontWeight: '700', color: '#1a1a1a' }}>
                                    Assisted Onboarding Terminal
                                </div>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.5fr', gap: '30px', alignItems: 'start' }}>
                                    <div style={{ background: '#ffffff', padding: '40px', borderRadius: '24px', boxShadow: '0 20px 40px rgba(0,0,0,0.06)', textAlign: 'center', border: '1px solid #edf2f7' }}>
                                        <h3 style={{ fontSize: '18px', fontWeight: '600', color: '#4a5568', marginBottom: '25px' }}>Pair for Assistance</h3>
                                        <div style={{ display: 'inline-block', padding: '20px', background: '#fff', borderRadius: '20px', boxShadow: '0 10px 25px rgba(0,0,0,0.03)', border: '1px solid #f0f0f0' }}>
                                            <QRCode value={JSON.stringify(assistantConfig)} size={220} level="H" includeMargin={false} />
                                        </div>
                                        <p style={{ marginTop: '25px', color: '#718096', fontSize: '14px', lineHeight: '1.6' }}>Direct the user to scan this code with their <br/> <strong>Sangrah app</strong> to begin session.</p>
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                                        <div style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', padding: '30px', borderRadius: '24px', color: '#fff', boxShadow: '0 15px 30px rgba(118, 75, 162, 0.2)' }}>
                                            <div style={{ opacity: 0.8, fontSize: '14px', fontWeight: '500', marginBottom: '5px' }}>Active Assistant</div>
                                            <div style={{ fontSize: '28px', fontWeight: '700' }}>{assistantConfig.assistant_name}</div>
                                            <div style={{ display: 'inline-block', marginTop: '15px', padding: '6px 12px', background: 'rgba(255,255,255,0.2)', borderRadius: '8px', fontSize: '12px', fontWeight: '600', letterSpacing: '1px' }}>READY FOR PAIRING</div>
                                        </div>
                                        <div style={{ background: '#fff', padding: '30px', borderRadius: '24px', boxShadow: '0 10px 20px rgba(0,0,0,0.02)', border: '1px solid #edf2f7' }}>
                                            <h4 style={{ fontSize: '16px', fontWeight: '600', color: '#2d3748', marginBottom: '20px' }}>Assistant Details</h4>
                                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                                                {[{ label: 'Assistant ID', value: assistantConfig.assistant_id }, { label: 'Organization', value: assistantConfig.bank_id }, { label: 'Access Point', value: assistantConfig.channel }].map((item, idx) => (
                                                    <div key={idx} style={{ padding: '15px', background: '#f7fafc', borderRadius: '12px' }}>
                                                        <div style={{ fontSize: '11px', color: '#a0aec0', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px' }}>{item.label}</div>
                                                        <div style={{ fontSize: '15px', fontWeight: '600', color: '#2d3748' }}>{item.value}</div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {selectedButton === 'KYC' && (
                            <div>
                                <div className='listTag'>KYC Identity Verification</div>
                                <div className="user-tablee">
                                    <table className="user-table" style={{ tableLayout: 'fixed', width: '100%', borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr>
                                                <th style={{ width: '70px', textAlign: 'center' }}>Sr No.</th>
                                                <th style={{ width: '20%', textAlign: 'center' }}>Email</th>
                                                <th style={{ width: '15%', textAlign: 'center' }}>KYC Request</th>
                                                <th style={{ width: '15%', textAlign: 'center' }}>KYC Status</th>
                                                <th style={{ width: '22%', textAlign: 'center' }}>Action</th>
                                                <th style={{ width: '18%', textAlign: 'center' }}>Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {sortedUsers.length > 0 ? sortedUsers.map((user, index) => {
                                                const brandPurple = '#764ba2';
                                                const lightPurple = '#e9e4ff';
                                                
                                                // Extract Date
                                                const rawDate = user.updatedAt || user.message.payload.data.timestamp;
                                                const formattedDate = rawDate 
                                                    ? new Date(rawDate).toLocaleDateString('en-GB', {
                                                        day: '2-digit', month: 'short', year: 'numeric',
                                                        hour: '2-digit', minute: '2-digit'
                                                      })
                                                    : 'N/A';

                                                return (
                                                    <tr key={user.bankUserId}>
                                                        <td style={{ textAlign: 'center' }}>{index + 1}</td>
                                                        <td style={{ textAlign: 'center', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                            {user.email || user.name || 'Unnamed User'}
                                                        </td>
                                                        <td style={{ textAlign: 'center' }}>
                                                            <span style={{ backgroundColor: lightPurple, color: brandPurple, padding: '4px 12px', borderRadius: '20px', fontSize: '11px', fontWeight: '700', display: 'inline-block' }}>
                                                                {(user.kycStatus || 'pending').toUpperCase()}
                                                            </span>
                                                        </td>
                                                        <td style={{ textAlign: 'center' }}>
                                                            {user.isVerified ? (
                                                                <div style={{ color: brandPurple, fontWeight: 'bold' }}>Verified</div>
                                                            ) : (
                                                                <div style={{ color: '#aaa' }}>Not Verified</div>
                                                            )}
                                                        </td>
                                                        <td style={{ textAlign: 'center' }}>
                                                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                                {user.isVerified ? (
                                                                    <span style={{ color: brandPurple, fontSize: '12px', fontWeight: 'bold' }}>Process Complete</span>
                                                                ) : user.kycStatus === 'rejected' ? (
                                                                    <span style={{ color: '#6b7280', fontSize: '12px', fontWeight: 'bold' }}>Rejected</span>
                                                                ) : (
                                                                    <button 
                                                                        className="review-btn" 
                                                                        style={{ backgroundColor: brandPurple, width: '140px', padding: '8px 0', borderRadius: '8px', color: 'white', border: 'none', cursor: 'pointer', fontWeight: '600' }}
                                                                        onClick={() => user.kycStatus === 'approved' ? handleVerifyUser(user.bankUserId) : handleSendKycRequest(user.userDid)}
                                                                    >
                                                                        {user.kycStatus === 'approved' ? 'Verify Information' : 'Send Request'}
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td style={{ textAlign: 'center', fontSize: '12px', color: '#555' }}>{formattedDate}</td>
                                                    </tr>
                                                );
                                            }) : (
                                                <tr><td colSpan="6" style={{ textAlign: 'center' }}>{loading ? 'Loading...' : 'No users found'}</td></tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default Admin;